import { PageTypeEnum } from '@moonpig/web-shared-products'
import {
  DYNAMIC_RESULTS_TYPE,
  GALLERY_RESULTS_TYPE,
  SEARCH_RESULTS_TYPE,
} from '../constants'

export const getGAListDataType = (pageType: string): string => {
  switch (pageType) {
    case PageTypeEnum.SEARCH:
      return SEARCH_RESULTS_TYPE
    case PageTypeEnum.GALLERY:
      return GALLERY_RESULTS_TYPE
    case PageTypeEnum.DYNAMIC:
      return `${DYNAMIC_RESULTS_TYPE} | organic`
    case PageTypeEnum.PAY_PER_CLICK:
      return `${DYNAMIC_RESULTS_TYPE} | ppc`
    default:
      return pageType
  }
}
